import { TestAdapter } from '@oracle/oraclejet-testing/UNSAFE_TestAdapter';

export class TableDisplayAdapter extends TestAdapter {}
